module.exports = __webpack_public_path__ + "static/media/cell-btn-cancel.76d239e3.svg";